import { render, staticRenderFns } from "./netInfo.vue?vue&type=template&id=b086e5ea&scoped=true&"
import script from "./netInfo.vue?vue&type=script&lang=js&"
export * from "./netInfo.vue?vue&type=script&lang=js&"
import style0 from "./netInfo.vue?vue&type=style&index=0&id=b086e5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b086e5ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b086e5ea')) {
      api.createRecord('b086e5ea', component.options)
    } else {
      api.reload('b086e5ea', component.options)
    }
    module.hot.accept("./netInfo.vue?vue&type=template&id=b086e5ea&scoped=true&", function () {
      api.rerender('b086e5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/setting/netInfo.vue"
export default component.exports